import { ContactTypeValue, EquipmentBrands } from '../enums';

export * from './audit-logs';
export * from './formats';
export * from './maps';
export * from './napco';

// Location contact slots. A party holds at most one slot per location (SWE-10178)
export const LOCATION_CONTACT_SLOTS = [
  ContactTypeValue.PRIMARY_CONTACT,
  ContactTypeValue.SECONDARY_CONTACT,
  ContactTypeValue.AUXILIARY_CONTACT,
];

export const n2pTheir911 = '10001000911';
export const n2pOur911 = '911';

// Fargate Spot gives ECS tasks a 2-minute interruption window after SIGTERM. Use a slightly
// shorter timeout so apps can finish their own shutdown path before the platform force-stops them.
export const ECS_GRACEFUL_SHUTDOWN_TIMEOUT_MS = 110000;

export const inhandMetricsQueryParams =
  'modem_info&_wan1_modem_status&_cur_sim&_wan1_network_type&_wan1_siglevel&_wan1_rsrp&_wan1_rsrq&_wan1_rssi&_wan1_imei&_wan1_imsi&_wan1_iccid&_wan1_plmn&_wan1_band&_wan1_lac&_wan1_cellid&_wan1_used_apn&wan0_ip&_mqtt_status&_wan0_get_ip&_active_link';

export const LAN_MAC_BRANDS = [EquipmentBrands.INHAND, EquipmentBrands.PEPWAVE];
export const WAN_MAC_BRANDS = [
  EquipmentBrands.CRADLEPOINT,
  EquipmentBrands.ERICSSON,
  EquipmentBrands.MOFI,
];

export const ethernetWan = 'ethernet-wan';

export enum ErrorReasonsEnum {
  UNKNOWN_SITE_ERROR = 'Unknown error during site creation',
  UNKNOWN_SUB_CREATE = 'Unknown error during subscription creation',
  UNKNOWN_SUB_DELETE = 'Unknown error during subscription deletion',
}
